export * from './create-initial-board';
export * from './create-initial-scoring';
export * from './get-coords-from-index';
export * from './get-indexes-in-winning-line';
export * from './get-square-label';
